import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { FulfilmentActivityDto } from "./FulfilmentActivityDto";

interface UseGetFulfilmentActivitiesParams {
    taxPayerWorkspaceId: string;
    levyId: string;
    year: number;
}

export function useGetFulfilmentActivities(
    params: UseGetFulfilmentActivitiesParams,
) {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();

    const query = useQuery<FulfilmentActivityDto[]>({
        queryKey: ["useGetFulfilmentActivities", workspaceId, params],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/${params.levyId}/years/${params.year}/tax-payers/${params.taxPayerWorkspaceId}/activities`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        initialData: [],
        placeholderData: [],
        meta: {
            resourceName: t("errors.resourceName.activities"),
        },
    });

    return query;
}
